export default "__VITE_ASSET__CsNVWk4Y__"